// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__2yZ97","cart":"navbar_cart__FxsDy"};